import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { api } from "./api/client";
import { notificationsKey } from "./api/hooks";
import { getInitData } from "./lib/telegram";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnReconnect: true } },
});

if (getInitData()) {
  queryClient.prefetchQuery({
    queryKey: notificationsKey,
    queryFn: () => api.list(),
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
